interface TelegramWindow {
    Telegram: {
        WebApp: {
            initData: string;
            initDataUnsafe: {
                query_id: string;
                user: {
                    id: number;
                };
                start_param: string;
            };
            ready: Function;
            expand: Function;
            isExpanded: Boolean;
            showAlert: Function;
            showConfirm: Function;
            openTelegramLink: Function;
            close: Function;
        }
    }
}

export default defineNuxtPlugin(async (nuxtApp) => {
    if ('tlgrm' === nuxtApp._route.name) {
        await import('../../vendors/telegram-web-app');
    }

    return {
        provide: {
            telegramWebApp: (window as any as TelegramWindow).Telegram?.WebApp,
        }
    };
});